<div
  class="form--wrapper"
  [nxLayout]="
    data.formData.gridOptions
      ? ((data.formData.gridOptions | joinStrings: ' ' : 'grid') ?? '')
      : 'grid'
  "
  *ngIf="data.formData && data.formGroup"
>
  @if (data.formData.showFormGroupErrors === 'top') {
    <app-error-box [data]="data"></app-error-box>
  }

  <ng-container
    *ngIf="
      data.formData.formColumns || data.formData.submitColumns;
      then alignedTemplate;
      else standardTemplate
    "
  ></ng-container>

  <div
    class="form-button--wrapper--alt nx-margin-top-m"
    *ngIf="!data.formData.submit.hidden && submitButtonStyle.text"
  >
    <button
      [nxButton]="submitButtonStyle.blockStyle ? 'block primary' : 'primary'"
      type="submit"
      [disabled]="data.formGroup.invalid"
    >
      {{ submitButtonStyle.text }}
    </button>
  </div>

  <ng-template #standardTemplate>
    <ng-template [ngTemplateOutlet]="fieldTemplate"></ng-template>

    <ng-template [ngTemplateOutlet]="submitTemplate"></ng-template>
  </ng-template>

  <ng-template #alignedTemplate>
    <div class="form--align--wrapper" nxRow nxRowAlignContent="end">
      <div class="form--align--fields" [nxCol]="data.formData.formColumns || '12'">
        <ng-template [ngTemplateOutlet]="fieldTemplate"></ng-template>
      </div>
      <div class="form--align--submit" [nxCol]="data.formData.submitColumns || '12'">
        <ng-template [ngTemplateOutlet]="submitTemplate"></ng-template>
      </div>
    </div>
  </ng-template>

  <ng-template #fieldTemplate>
    <div
      nxRow
      rowJustify="center"
      class="form--fields--wrapper nx-margin-bottom-m"
      *ngIf="data.formData.form.length > 0"
    >
      <ng-container *ngFor="let item of data.formData.form; let i = index">
        <ng-container *ngIf="data.formGroup && !item.hidden">
          <div class="form--fields" [nxCol]="item | fieldColumns" [ngClass]="item | fieldClasses">
            <h3 *ngIf="item.title">{{ item.title | translate }}</h3>
            <p *ngIf="item.description">{{ item.description | translate }}</p>
            <dynamic-component
              [component]="item | dynCompConverter: data"
              (CreatedComponent)="onCreatedComponent($event)"
            ></dynamic-component>
          </div>
        </ng-container>
      </ng-container>
      @if (data.formData.showFormGroupErrors === 'bottom') {
        <div class="form--error" [nxCol]="'12'">
          <app-error-box [data]="data"></app-error-box>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #submitTemplate>
    <div class="form-button--wrapper" *ngIf="!data.formData.submit.hidden">
      <button
        *ngIf="isStep"
        [nxButton]="data.formData.back?.nxButton || 'secondary'"
        type="button"
        [disabled]="data.formData.back?.disabled"
        nxStepperPrevious
        [ngClass]="data.formData.back?.class"
      >
        {{ data.formData.back?.text || 'azForm.common.backButtonLabel' | translate }}
      </button>

      @if (
        data.formData.additionalButton &&
        !data.formData.additionalButton.hidden &&
        !data.formData.additionalButton.nxPlainButton
      ) {
        <button
          [nxButton]="data.formData.additionalButton.nxButton ?? 'secondary'"
          (click)="onAdditionalButtonClick($event)"
          type="button"
          [disabled]="data.formData.additionalButton.disabled"
          [ngClass]="data.formData.additionalButton.class"
        >
          <span class="form-button--icon">
            @if (data.formData.additionalButton.icon) {
              <nx-icon [name]="data.formData.additionalButton.icon"></nx-icon>
            }
            {{ data.formData.additionalButton.text | translate }}
          </span>
        </button>
      } @else if (
        data.formData.additionalButton &&
        !data.formData.additionalButton.hidden &&
        !data.formData.additionalButton.nxButton
      ) {
        <button
          [nxPlainButton]="data.formData.additionalButton.nxPlainButton ?? ''"
          (click)="onAdditionalButtonClick($event)"
          type="button"
          [disabled]="data.formData.additionalButton.disabled"
          [ngClass]="data.formData.additionalButton.class"
        >
          <span class="form-button--icon">
            @if (data.formData.additionalButton.icon) {
              <nx-icon [name]="data.formData.additionalButton.icon"></nx-icon>
            }
            {{ data.formData.additionalButton.text | translate }}
          </span>
        </button>
      }

      <button
        [nxButton]="data.formData.submit.nxButton || 'primary'"
        [type]="isStep && !isLastStep ? 'button' : 'submit'"
        (click)="onNextStep($event)"
        [disabled]="data.formData.submit.disabled || data.formGroup.invalid"
        [ngClass]="data.formData.submit.class"
      >
        {{
          isStep && !isLastStep
            ? (data.formData.nextStep?.text || 'azForm.common.nextButtonLabel' | translate)
            : (data.formData.submit.text || 'azForm.common.submitButtonLabel' | translate)
        }}
      </button>
    </div>
  </ng-template>
</div>
